export default __webpack_public_path__ + "static/media/profile-pic.236b6ae6.png";